module.exports = __webpack_public_path__ + "img/icon-pregnancy.c8ab873d.png";